import R from 'ramda';

export const errors = (data: any): string[] => {
  return R.pathOr([], ['errors', 0, 'description'], data);
};

export const errorDescriptions = (errors: any[]): string[] => {
  return errors.map((error: any) => error.description);
};
